import React, { useContext, useState } from "react";

import contacthero from "../../images/contacthero.jpg";
import ScrollAnimation from "react-animate-on-scroll";
// import homeSegment3img2 from "../../images/homeSegment3img2.jpg";
import { Helmet } from "react-helmet-async";
import logo from "../../images/logo.png";
import { SectionsContext } from "../../store/section-context";
import { Link, useOutletContext } from "react-router-dom";
import Loader from "../../components/loader/loader";

function Blog() {
  const { blog } = useContext(SectionsContext);
  const { meta, hero } = blog;
  const { posts, loading } = useOutletContext();
  const [currentPage, setCurrentPage] = useState(1);

  if (loading) {
    return <Loader />;
  }

  const itemsPerPage = 2;

  const totalPages = Math.ceil(posts.length / itemsPerPage);

  const isInFirstPage = currentPage === 1;
  const isInLastPage = currentPage === totalPages;

  // Calculate the index of the first and last item on the current page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  // Get current posts
  const currentPosts = posts.slice(indexOfFirstItem, indexOfLastItem);

  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  return (
    <div>
      <Helmet>
        {/* Title and Meta Description */}
        <title>{meta.title}</title>
        <meta name="description" content={meta.description} />
        <meta name="keywords" content={meta.keywords} />
        <meta property="og:title" content={meta.title} />
        <meta property="og:description" content={meta.description} />
        <meta
          property="og:url"
          content="https://www.brookshealthandcare.com/"
        />
        <meta property="og:image" content={logo} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Brooks Health and Care" />
        <meta property="og:locale" content="en_GB" />{" "}
        <meta name="twitter:card" content="summary_large_image" />{" "}
        <meta name="twitter:title" content={meta.title} />
        <meta name="twitter:description" content={meta.description} />
        <meta name="twitter:image" content={logo} />
        <link
          rel="canonical"
          href="https://www.brookshealthandcare.com/"
        />{" "}
        <meta name="author" content="Brooks Health and Care" />
        <meta name="robots" content="index, follow" />{" "}
      </Helmet>
      <div
        className="aboutheroreplacement p-md-5 p-4"
        style={{
          backgroundImage: `url(${hero.uri || contacthero})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          width: "100%",
          backgroundColor: "rgb(0 0 0 / 70%)",
        }}
      >
        <div className="aboutheroreplacementbox">
          <div className="lhsheading">
            {" "}
            <span className="thick-dot"></span>{" "}
            <span className="ps-1"> {hero.headline}</span>{" "}
          </div>

          <div className="lhssubtitle pb-1 pt-3">{hero.subheadline} </div>
        </div>
      </div>

      {totalPages === 0 ? (
        <div className="d-flex justify-content-center py-5">
          <Link to="/">
            <button
              type="button"
              className="testimonialbtn mx-2" // Same class for styling
              style={{
                minWidth: "8rem",
                display: "flex",
                justifyContent: "center", // Center the text inside
                opacity: "1", // No disabled effect
              }}
            >
              <span
                className="text-white"
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center", // Center the text
                  alignItems: "center",
                }}
              >
                No posts yet.
              </span>
            </button>
          </Link>
        </div>
      ) : (
        <>
          <div className="blogcontainer d-flex flex-wrap justify-content-between">
            <div className="twocolumngrid blog2columngrid px-1 px-md-5">
              {currentPosts.map((post, index) => {
                const slug = post.title
                  .toLowerCase()
                  .trim()
                  .replace(/[^a-z0-9\s-]/g, "")
                  .replace(/\s+/g, "-")
                  .replace(/-+/g, "-");

                const preview = post.body
                  .replace(/<[^>]*>/g, "")
                  .split(" ")
                  .slice(0, 40)
                  .join(" ");

                const date = new Date(post.createdAt).toLocaleDateString(
                  "en-US",
                  { month: "long", day: "numeric", year: "numeric" }
                );

                return (
                  <ScrollAnimation
                    key={index}
                    className=""
                    animateIn="bounceInLeft"
                    animationOut="fadeOut"
                  >
                    <div className="homesection2subgridgroup d-flex flex-column justify-content-between h-100">
                      <div>
                        <img
                          className="blogpageimg py-3"
                          src={post.uri || logo}
                          alt=""
                        />
                      </div>
                      <div className="blogdate">{date}</div>
                      <div className="aboutsegment3boxtitle  pt-3 pb-2">
                        {post.title}
                      </div>
                      <div className="pt-2 homesection2subgridsubheading homesection4subgridsubheading">
                        {preview}
                        {"..."}

                        {/* In a world that often emphasizes the importance of acquiring
                  and achieving, the act of giving stands out as a powerful
                  counterbalance. Giving, in its truest form, is not merely an
                  action but an art that enriches both the giver and the
                  receiver. Let’s delve into the essence of giving and explore
                  its transformative power... */}
                      </div>
                      <div className="pt-4 text-start">
                        {" "}
                        <button className="testimonialbtn">
                          {" "}
                          <Link
                            to={`${post._id}/post/${slug}`}
                            className="text-white"
                          >
                            Read More{" "}
                            <i className="ps-2 fa-solid fa-arrow-right"></i>
                          </Link>
                        </button>{" "}
                      </div>
                    </div>
                  </ScrollAnimation>
                );
              })}
            </div>
          </div>

          <div className="d-flex justify-content-center py-5">
            <button
              type="button"
              className={`testimonialbtn mx-2 ${
                isInFirstPage ? "disabled" : ""
              }`}
              onClick={prevPage}
              disabled={isInFirstPage}
              style={{
                minWidth: "8rem",
                display: "flex",
                justifyContent: "flex-start",
                opacity: isInFirstPage ? "0.6" : "1",
              }}
            >
              <span
                className="text-white"
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              >
                <i className="fa-solid fa-arrow-left ps-2 me-2"></i> Previous
              </span>
            </button>

            <span
              className="text-black mx-3 align-self-center"
              style={{ whiteSpace: "nowrap" }}
            >
              {currentPage} of {totalPages}
            </span>
            <button
              type="button"
              className={`testimonialbtn mx-2 ${
                isInLastPage ? "disabled" : ""
              }`}
              onClick={nextPage}
              disabled={isInLastPage}
              style={{
                opacity: isInLastPage ? "0.6" : "1",
                minWidth: "8rem",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <span
                className="text-white"
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                Next <i className="fa-solid fa-arrow-right ps-2"></i>
              </span>
            </button>
          </div>
        </>
      )}
    </div>
  );
}
export default Blog;
